export function SubmitLayoutService($resource) {
  'ngInject';

  return $resource('/api/submit', {}, {
    query: { method: 'POST', isArray: true }
  });
}



// WEBPACK FOOTER //
// ./client/components/canvas/submitLayout.service.js